<template>
    <div class="block-child">
        <BlockParallax
            class="block-child__icon block-child__icon-lightning"
            speed="15"
            direction="right"
            transform="rotate"
            fixed>
            <img src="@/assets/images/icons/ll-8.png">
        </BlockParallax>
        <BlockParallax
            class="block-child__icon block-child__icon-hp"
            speed="10"
            direction="left"
            transform="rotate"
            fixed>
            <img src="@/assets/images/icons/hp-2.png">
        </BlockParallax>

        <img
            srcset="../assets/1215-child.jpg, ../assets/1215-child@2x.jpg 2x"
            src="../assets/1215-child.jpg"
            class="block-child__img"
        >
        <div class="image-caption image-caption--overlap-right">Двор-парк в проекте «Варшавское шоссе 141»</div>

        <BlockParallax
            class="block-child__content"
            fixed
            speed="8"
            direction="top"
            transform="translateY"
        >
            <span class="block-child__title">Ребенок и мир</span>
            <p class="block-child__text">
                Кажется, в этом возрасте влияние на ребенка может оказывать кто угодно, но только не&nbsp;собственные родители. В глазах подростка их знания о жизни стремительно обесцениваются вместе с авторитетом. Но&nbsp;ему все равно нужен взрослый рядом, тот, к кому он будет прислушиваться. И если это будет не родные мама и папа, а тренер или&nbsp;преподаватель — это тоже нормально.
            </p>
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-child {
        margin-top 3rem
        margin-left -1rem
        margin-right -1rem
        font-size 0
        position relative

        +layout-sm-and-up() {
            margin-left 0
            margin-right 0
        }
        +layout-md-and-up() {
            margin-top 5rem
        }

        &__img {
            position relative
            z-index 4
            object-fit contain
            +layout-sm-and-up() {
                max-width 100%
            }

            +layout-xs() {
                width 100%
                height 355px
                object-fit cover
            }
        }

        &__content {
            position relative
            max-width 46rem
            background-color #8d91e6
            padding 2rem 2rem 3rem 2rem
            margin-left 4rem
            margin-top -10rem
            z-index 5
            +layout-sm-and-up() {
                margin-left auto
                margin-right 8rem
            }
            +layout-md-and-up() {
                padding 4rem 6rem
                padding-bottom 7rem
                margin -8rem auto 0 8rem
                position relative
            }
        }

        &__title {
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-white
            +layout-md-and-up() {
                font-size 3rem
            }
        }

        &__text {
            color $color-white
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
        }

        &__icon {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-hp {
            z-index 100
            position absolute
            right -20px
            top -59px
            width 12rem
            height 12rem
            +layout-md-and-up() {
                top auto
                bottom 12rem
                right 18rem
                width 10.5rem
                height 10rem
            }
        }
        
        &__icon-lightning {
            +layout-md-and-up() {
                top auto
                bottom 8rem
                left -7rem
                width 7rem
                img {
                    transform rotate(-35deg)
                }
            }
        }
    }
    .image-caption {
        &--overlap-right {
            padding-left 60%
        }
    }
</style>
